import React from 'react';
import { useTranslation } from 'react-i18next';

import { AlertComponent } from 'components/_basic/AlertComponent';
import { Card } from 'components/_basic/Card';
import { Loader } from 'components/_basic/Loader/Loader';
import OutletTable from 'components/_basic/OutletTable/OutletTable';

import { useGetColumns } from './columns';
import { IPaymentHistoryProps } from './types';
import { EmptyPage } from '../EmptyPage/EmptyPage';

export const PaymentHistory: React.FC<IPaymentHistoryProps> = (props) => {
  const { payments, totalCount, isLoading, error, page, rowsPerPage, onPageChange, onRowsPerPageChange } = props;
  const columns = useGetColumns()

  const { t } = useTranslation();

  if (isLoading) {
    return (
      <Card title={t('paymentHistory')}>
        <Loader />
      </Card>
    );
  }

  if (error) {
    return (
      <Card title={t('paymentHistory')}>
        <AlertComponent severity="error" message={error.message} />
      </Card>
    );
  }

  return (
    <Card title={payments.length ? t('paymentHistory') : ''}>
      {payments.length ? (
        <OutletTable
          data={payments}
          totalCount={totalCount}
          columns={columns}
          page={page}
          rowsPerPage={rowsPerPage}
          onPageChange={onPageChange}
          onRowsPerPageChange={onRowsPerPageChange}
        />
      ) : (
        <EmptyPage />
      )}
    </Card>
  );
};
